"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStepName = isStepName;
exports.isStepPath = isStepPath;
const stepNameRegex = /^[a-z0-9_-]+$/i;
function isStepName(stepName) {
    return typeof stepName === 'string' && stepNameRegex.test(stepName);
}
const stepPathRegex = /^[a-z0-9_-]+(\.[a-z0-9_-]+)+$/i;
function isStepPath(stepPath) {
    return typeof stepPath === 'string' && stepPathRegex.test(stepPath);
}
//# sourceMappingURL=matchers.js.map